<template>
  <div id="app">
    <index></index>
  </div>
</template>
<script>
import index from "@/views/index.vue";
export default {
  components: {
    // 组件注册
    index
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // Vue实例渲染完成后执行
  }
};
</script>
<style lang="scss">
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  text-decoration: none;
  list-style: none;
}
body {
  background-color: #f2f2f2;
}
</style>
